import { useAuth } from '../Components/Auth/AuthProvider';

export const useApiFetch = () => {
  const { acquireToken } = useAuth();

  const getHeaders = async (forceRefresh = false) => {
    const token = await acquireToken(forceRefresh);
    if (!token) {
      throw new Error('Failed to acquire authentication token');
    }
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    };
  };

  const fetchData = async (url, method = 'GET', body = null, retry = true) => {
    try {
      const headers = await getHeaders();
      const options = {
        method,
        headers
      };
      if (body) {
        options.body = JSON.stringify(body);
      }

      const res = await fetch(url, options);

      if (res.status === 401 && retry) {
        console.log('Token expired (401), refreshing and retrying...');
        // Force refresh
        const newHeaders = await getHeaders(true);
        options.headers = newHeaders;
        const retryRes = await fetch(url, options);
        if (!retryRes.ok) {
          throw new Error(`HTTP error! status: ${retryRes.status}`);
        }
        return retryRes.json();
      }

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  };

  return fetchData;
};
